var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagePlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.85105 5.80438C8.77024 5.57713 8.62118 5.38041 8.42427 5.24115C8.22737 5.10188 7.99223 5.02687 7.75105 5.02637H6.84805C6.59043 5.02503 6.34146 5.11925 6.14929 5.29083C5.95711 5.46241 5.83539 5.69915 5.80765 5.95527C5.77991 6.2114 5.84813 6.46871 5.99911 6.67745C6.15009 6.88619 6.37311 7.03154 6.62505 7.08537L8.00005 7.38538C8.2812 7.44693 8.52969 7.6102 8.69778 7.84383C8.86586 8.07746 8.94168 8.36497 8.91068 8.6511C8.87967 8.93724 8.74402 9.20182 8.52979 9.39402C8.31556 9.58622 8.03786 9.69248 7.75005 9.69237H6.97305C6.46505 9.69237 6.03305 9.36838 5.87305 8.91538M7.36205 5.02637V3.85938M7.36205 10.8594V9.69338M2.49805 13.9954V11.4954H4.99805",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8874 6.30153C14.1529 7.71675 13.941 9.18005 13.2849 10.4618C12.6287 11.7435 11.5656 12.7711 10.2623 13.3833C8.95904 13.9954 7.48937 14.1575 6.084 13.8441C4.67863 13.5307 3.41711 12.7595 2.49744 11.6515M1.11144 8.69353C0.845964 7.27832 1.05792 5.81502 1.71403 4.53329C2.37014 3.25157 3.43327 2.22398 4.73656 1.61181C6.03984 0.999646 7.50951 0.837555 8.91488 1.15098C10.3202 1.46441 11.5818 2.2356 12.5014 3.34353",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.502 0.999512V3.49951H10.002",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePlanIcon);
export default __webpack_public_path__ + "static/media/manage-plan-icon.32ad760e45df077c8f9e8d039d8d80c9.svg";
export { ForwardRef as ReactComponent };